<template>
    <div>
        <b-modal 
            id="modal-PreventiveMaintenance" 
            title="Create Preventive Maintenance"
            :no-close-on-backdrop="true" 
            no-close-on-esc 
            hide-footer 
            centered
            v-model="modals.preventive.open"
            ref="modal-preventive-maintenance">
            <b-form class="formV2">
                <b-row>
                    <b-col>
                        <gofix-form-input label="code" v-model="dataGen.sor_code" @change="checkExistCode">
                            <template v-if="errorLogs.sor_code" #gofixInput:text:after-desc>
                                <p class="desc color-error">This code already exists!</p>
                            </template>
                        </gofix-form-input>
                    </b-col>
                    <b-col>
                        <gofix-form-input label="name" v-model="dataGen.sor_name"></gofix-form-input>
                    </b-col>
                </b-row>
                <b-form-checkbox @input="showDescription = !showDescription" class="absoluteCheckbox bottom-0"><span>Add Description</span></b-form-checkbox>
                <b-row class="mt-20">
                    <b-col :md="12">
                        <gofix-form-input v-if="showDescription" label="Description" v-model="dataGen.description"></gofix-form-input>
                    </b-col>
                    <b-col>
                        <gofix-form-dropdown
                            label="Frequency"
                            vLabel="recurring_mode"
                            :clearable="false"
                            required
                            append-to-body
                            :reduce="option => option.id"
                            v-model="dataGen.sor_recurring_mode_id"
                            :options="recurringModes">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col>
                        <gofix-form-tree
                            label="Service Category"
                            v-model="dataGen.service_category"
                            valueFormat="object"
                            :options="services"
                            :normalizer="normalizer"
                            :load-options="loadOptionService">
                        </gofix-form-tree>
                    </b-col>
                </b-row>
                <b-row class="mt-20">
                    <b-col>
                        <gofix-form-input-date
                            popoverDirection="top"
                            v-model="dataGen.start_date"
                            label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col>
                        <gofix-form-input-date
                            popoverDirection="top"
                            v-model="dataGen.end_date"
                            label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
                <b-row class="mt-20">
                    <b-col md="6">
                        <gofix-form-dropdown
                            label="Checklist Temp."
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            required
                            append-to-body
                            :reduce="option => option.id"
                            v-model="dataGen.checklist_template_id"
                            :options="checklistTemplates">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-number
                            label="Unit price"
                            desc=" "
                            v-model="dataGen.unit_price"
                            prefix="$">
                        </gofix-form-input-number>
                    </b-col>
                </b-row>
                <div class="content mt-20">
                    <label class="mb-0">Location</label>
                    <div class="info-right">{{ displayData.location | getRootLocation}}</div>
                </div>
                <div class="content">
                    <label class="mb-0">Equipment Group</label>
                    <div class="info-right" v-html="displayData.equipmentGroup"></div>
                </div>
                <div class="content">
                    <label class="mb-0">Equipment List <span v-if="flag_equipment_type == true" style="white-space:normal">Not the same Equipment Group</span></label>
                    <div class="info-right" v-html="displayData.equipmentList"></div>
                </div>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="checkPreventiveMaintenance" :loading="modals.preventive.loading" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal 
            id="modal-PreventiveMaintenanceChild" 
            title="Existing Preventive Maintenace" 
            :no-close-on-backdrop="true" 
            no-close-on-esc
            hide-footer 
            centered
            v-model="modals.preventive_existing.open"
            ref="modal-preventive-maintenance-child"
            @close="openModalPreventiveMaintenance">
            <ul class="list" v-bind:class="{'run-loading':equipmentLoading.generate_jobs}">
                <template  v-if="existing_maintenance.length > 0">
                    <li v-for="(item, index) in existing_maintenance">
                        <b-row>
                            <b-col md="3">
                                <div class="content">
                                    <label>Frequency</label>
                                    <div class="info-right">{{ item.get_sor_recurring_mode ? item.get_sor_recurring_mode.recurring_mode : '-' }}</div>
                                </div>
                            </b-col>
                            <b-col md="3">
                                <div class="content">
                                    <label>Code</label>
                                    <div class="info-right">{{ item.id }} - {{ item.sor_code }}</div>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="content">
                                    <label>Name</label>
                                    <div class="info-right">{{ item.name ? item.name : '-' }}</div>
                                </div>
                            </b-col>
                            <b-col md="2">
                                <gofix-button label="Reuse" @click="savePreventiveMaintenance(item.id)" outline></gofix-button>
                            </b-col>
                        </b-row>
                    </li>
                </template>
                <li>
                    <b-row>
                        <b-col md="3">
                            <div class="content">
                                <label>Frequency</label>
                                <div class="info-right">{{ dataGen.sor_recurring_mode_id }}</div>
                            </div>
                        </b-col>
                        <b-col md="3">
                            <div class="content">
                                <label>Code</label>
                                <div class="info-right">{{ dataGen.sor_code }}</div>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="content">
                                <label>Name</label>
                                <div class="info-right">{{ dataGen.sor_name }}</div>
                            </div>
                        </b-col>
                        <b-col md="2">
                            <gofix-button class="pull-right" label="create new" @click="savePreventiveMaintenance" outline></gofix-button>
                        </b-col>
                    </b-row>
                </li>
            </ul>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import moment from 'moment';
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};
export default {
    name: 'preventive-maintenance',
    components: {},
    props: {
        value: {
            required: false,
            default: null
        },
        selected: {
            type: Array,
            required: false,
            default: []
        }
    },
    data () {
        return {
            modals: {
                preventive: {
                    open:    this.value,
                    loading: false
                },
                preventive_existing: {
                    open: false
                }
            },
            open:    this.value,
            loading: false,
            services:           [],
            checklistTemplates: [],
            dataGen: {
                sor_id:                null,
                sor_code:              null,
                sor_name:              null,
                unit_price:            null,
                checklist_template_id: null,
                sor_recurring_mode_id: null,
                service_category_id:   null,
                description:           null,
                start_date:            null,
                end_date:              null,
                equipment_group_id:    null,
                property_id:           [],
                equipment_list:        [],
                maintenance_id:        0,
                client_contract_id:    this.$route.params.id
            },
            displayData: {
                location:      null,
                equipmentList: null,
                equipmentGroup:null
            },
            errorLogs: {
                sor_code: false
            },
            existing_maintenance: [],
            flag_equipment_type:  false,
            showDescription:      false
        };
    },
    computed: {
        ...mapGetters({
            ClientContractID: "ContractController/ClientContractID",
            equipmentLoading: "EquipmentV2Controller/equipmentLoading",
            recurringModes:   "SorRecurringModesController/sorRecurringModes",
            equipments:        "EquipmentV2Controller/equipments",
        })
    },
    filters:{
        getRootLocation: function(value) {
            if (!value) return "N/A";
            let locations = value.split(",");
            let array_locations = [];
            let min_path = 0;
            let path_location = [];
            locations.forEach(element => {
                let array_element = element.split(">>");
                array_locations.push(array_element);
                if(!min_path){
                    min_path = array_element.length;
                }else if(min_path > array_element.length){
                    min_path = array_element.length;
                }
            });
            for(let i = 0; i < min_path; i++){
                for(let j = 0; j < array_locations.length; j++){
                    let subPath = array_locations[j][i].trim();
                    if(!path_location[i]) {
                        path_location.push(subPath);
                    }else{
                        if(path_location[i] !== subPath){
                            path_location.splice(i, 1);
                            return path_location.join(" >> ");
                        }
                    }
                }
            }
            return path_location.join(" >> ");
        }
    },
    watch: {
        value: function(val) {
            this.modals.preventive.open = val;
        },
        "modals.preventive.open": function(val) {
            this.$emit("input", val);
            if(val) {
                this.openModalPreventiveMaintenance();
            }
        },
        "dataGen.service_category": function(val) {
            this.dataGen.service_category_id = null;
            if(val && val.id) {
                this.dataGen.service_category_id = val.id;
            }
        }
    },
    created() {
        this.$store.dispatch('SorRecurringModesController/getListSorRecurringModes');
        this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [ -1, 1, { contract_id: this.$route.params.id } ])
        .then(response => { 
            this.checklistTemplates = response.data.data.items 
        });
    },
    methods:{
        normalizer(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.text,
                    children: node.children
                };
            return {
                id: node.data.id,
                label: node.text,
                children: undefined
            };
        },
        savePreventiveMaintenance(sor_id = 0) {
            if(sor_id) {
                this.dataGen.sor_id = sor_id
            }
            
            let params = JSON.parse(JSON.stringify(this.dataGen));
            params.unit_price = this.$accounting.unformat(params.unit_price);
            params.start_date = moment(new Date(params.start_date)).format('YYYY-MM-DD')
            params.end_date   = moment(new Date(params.end_date)).format('YYYY-MM-DD');
            this.$store.dispatch('EquipmentV2Controller/generateJobs', params)
            .then(result => {
                this.$alertNotification(this.$notificationV2('adding', 'preventive_maintenance'));
                this.modals.preventive_existing.open = false;
                this.modals.preventive.open          = false;
            })
            .catch(error => {
                if(error.response && error.response.data.error.message) {
                    for (const [key, value] of Object.entries(error.response.data.error.message)) {
                        return this.$alertNotification(value[0], "danger");
                    }
                }
            })
        },
        checkExistCode(val){
            if(val) {
                this.errorLogs.sor_code = false;
                global.axios.get(`api/sor/check-existing`, {
                    params: {
                        sor_code: val,
                        contract_id: this.$route.params.id
                    }
                })
                .then(response => {
                    this.errorLogs.sor_code = response.data.data.existing;
                })
                .catch(error => {
                    this.errorLogs.sor_code = true;
                });
            }
        },
        checkPreventiveMaintenance() {
            if(!this.dataGen.sor_code) {
                return this.$alertNotification('Please enter code field.', 'danger');
            }

            if(this.errorLogs.sor_code) {
                return this.$alertNotification('This code already exists.', 'danger');
            }

            if(!this.dataGen.sor_name) {
                return this.$alertNotification('Please enter Name field.', 'danger');
            }

            if(!this.dataGen.sor_recurring_mode_id) {
                return this.$alertNotification('Please select frequency.', 'danger');
            }

            if(!this.dataGen.service_category_id) {
                return this.$alertNotification('Please select service category.', 'danger');
            }

            if(!this.dataGen.start_date) {
                return this.$alertNotification('Please select start date.', 'danger');
            }

            if(!this.dataGen.end_date) {
                return this.$alertNotification('Please select end date.', 'danger');
            }

            if(!this.dataGen.checklist_template_id) {
                return this.$alertNotification('Please select checklist template.', 'danger');
            }

            if(!this.dataGen.equipment_group_id) {
                return this.$alertNotification('Please select equipment group.', 'danger');
            }

            if(!this.dataGen.property_id) {
                return this.$alertNotification('Please select property.', 'danger');
            }

            this.dataGen.equipment_list = JSON.stringify(this.dataGen.equipment_list);

            if(this.modals.preventive.loading) return;
            this.modals.preventive.loading = true;

            let params = {
                start_date: moment(new Date(this.dataGen.start_date)).format('YYYY-MM-DD'),
                end_date: moment(new Date(this.dataGen.end_date)).format('YYYY-MM-DD'),
                equipment_list: this.dataGen.equipment_list,
                sor_recurring_mode_id: this.dataGen.sor_recurring_mode_id,
                service_category_id: this.dataGen.service_category_id,
                sor_code: this.dataGen.sor_code,
                sor_name: this.dataGen.sor_name,
                unit_price: this.$accounting.unformat(this.dataGen.unit_price_tmp),
                contract_id: this.$route.params.id
            }
            this.$store.dispatch('EquipmentV2Controller/generateJobsCheckMaint', params)
            .then(response => {
                this.existing_maintenance            = response.data.data
                this.modals.preventive_existing.open = true;
                this.modals.preventive.open          = false;
                this.modals.preventive.loading       = false;
            })
            .catch(error => {
                this.modals.preventive.loading       = false;
                this.dataGen.equipment_list = JSON.parse(this.dataGen.equipment_list);
                if(error.response) this.$alertNotification(error.response.data.error.message, 'danger');
            });
        },
        async openModalPreventiveMaintenance() {
            // reset data
            this.dataGen = {
                sor_id:                null,
                sor_code:              null,
                sor_name:              null,
                unit_price:            null,
                checklist_template_id: null,
                sor_recurring_mode_id: null,
                service_category_id:   null,
                description:           null,
                start_date:            null,
                end_date:              null,
                equipment_group_id:    null,
                property_id:           [],
                equipment_list:        [],
                maintenance_id:        0,
                client_contract_id:    this.$route.params.id
            };

            this.flag_equipment_type        = false
            this.displayData.location       = '';
            this.displayData.equipmentList  = '';
            this.displayData.equipmentGroup = '';
            this.dataGen.equipment_list     = [];

            let typeFlag    = '';
            let check       = true;
            let checkType   = true;
            let checkActive = "";
            this.equipments.items.forEach(item=>{
                if(this.selected.includes(item.id)){
                    if(!item.is_active || !item.location_info.is_active) {
                        checkActive += `${item.tag_name}, `;
                        return;
                    } 

                    if(!typeFlag){
                        typeFlag = item.equipment_type;

                        this.displayData.equipmentGroup = item.equipment_type;
                        this.dataGen.equipment_group_id = item.equipment_group_id;

                        this.dataGen.property_id.push(item.location_info.id);
                        this.dataGen.equipment_list.push({id: item.id, name: item.tag_name});

                        this.displayData.equipmentList += `, ${item.tag_name}`;
                        this.displayData.location      += `, ${item.location_info.root_path}`;
                    } else {
                        if(item.equipment_type == typeFlag) {
                            this.dataGen.property_id.push(item.location_info.id);
                            this.dataGen.equipment_list.push({id: item.id, name: item.tag_name});
                            
                            this.displayData.equipmentList += `, ${item.tag_name}`;
                            this.displayData.location      += `, ${item.location_info.root_path}`;
                        } else {
                            this.flag_equipment_type       = true;
                            this.displayData.equipmentList += `, <strike>${item.tag_name}</strike>`;
                        }
                    }
                    
                }
            });

            this.displayData.equipmentList = this.displayData.equipmentList.replace(/,/i, "");
            this.displayData.location      = this.displayData.location.replace(/,/i, "");
            if(checkActive) {
                this.modals.preventive.open = false;
                return this.$alertNotification(`The following equipements: ${checkActive.replace(/, $/," ")} is inactive or has inactive properties, so Preventive Maintenance cannot be created.`, 'danger');
            }

            if(!this.dataGen.sor_code || this.errorLogs.sor_code){
                //pre-fill PM-code with a unique ID
                this.dataGen.sor_code = "PM-CODE-" + moment().format("DDMMYY-ssSSS");
                await this.checkExistCode(this.dataGen.sor_code);
                while (this.errorLogs.sor_code) {
                    this.dataGen.sor_code = "PM-CODE-" + moment().format("DDMMYY-ssSSS");
                    await this.checkExistCode(this.dataGen.sor_code);
                }
            }
            this.services = await this.getServiceCategory(0, this.$route.params.id);
            if(check && checkType && !this.modals.preventive.open) {
                this.modals.preventive.open = true;
            }
        },
        /*--- Service Category ---*/
        getServiceCategory(service_category_root_id, contract_id) {
            return new Promise (( resolve, reject ) => {
                global.axios(`api/contracts/${contract_id}/tree-service-categories/${service_category_root_id}`, { method: "GET", headers: { Accept: "application/json", } })
                .then(response => { resolve(response.data.data) }).catch(error => {});
            });
        },
        loadOptionService({ action, parentNode, callback }) {
            if (action === LOAD_CHILDREN_OPTIONS ) {
                simulateAsyncOperation(async () => {
                    parentNode.children = await this.getServiceCategory(parentNode.data.id, this.$route.params.id)
                    callback()
                })
            }
        },
    }
}
</script>
